/* eslint-disable react/prop-types */
import { Header as CarbonHeader } from '@carbon/react';

export const Header = ({ children, ...props }) => (
  <CarbonHeader {...props}>{children}</CarbonHeader>
);
